import axios from "axios";
import { message } from "ant-design-vue";

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";

// 创建 sponsor/smo 通用服务（响应码约定：200 成功）
function createService(baseURL) {
  const service = axios.create({ baseURL, timeout: 30000 });

  service.interceptors.request.use(
    (config) => {
      const token = config.headers["X-Token"];
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
        delete config.headers["X-Token"];
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  service.interceptors.response.use(
    (res) => {
      const code = res.data.code || 200;
      const msg = res.data.msg || res.data.message || "系统错误";

      if (code === 401) {
        message.warning("登录状态已过期，请重新登录");
        return Promise.reject(msg);
      } else if (code === 901) {
        return Promise.reject({ code: 901, data: res.data.data, msg });
      } else if (code === 500) {
        message.error(msg);
        return Promise.reject(msg);
      } else if (code !== 200) {
        message.error(msg);
        return Promise.reject(msg);
      }
      return res.data;
    },
    (error) => {
      const { status, data } = error.response || {};
      if (status === 500) {
        message.error(data?.message || "服务器错误");
      } else if (status !== 401) {
        message.error(data?.message || "请求失败");
      }
      return Promise.reject(error);
    }
  );

  return service;
}

// 创建 filecert 服务（响应码约定：1 成功）
function createFilecertService(baseURL) {
  const service = axios.create({ baseURL, timeout: 30000 });

  service.interceptors.response.use(
    (res) => {
      const code = res.data.code;
      const msg = res.data.msg || res.data.message || "请求失败";
      if (code !== 1) {
        message.error(msg);
        return Promise.reject(new Error(msg));
      }
      return res.data;
    },
    (error) => {
      message.error(
        error?.response?.data?.msg ||
        error?.response?.data?.message ||
        "网络错误"
      );
      return Promise.reject(error);
    }
  );

  return service;
}
export const sponsorService = createService("/sponsor/api");
export const smoService = createService("/smo/api");
export const agentService = createFilecertService("/agent/api");
export const filecertService = createFilecertService("/filecert/api");

export const sponsorPost = (url, data = {}, config = {}) =>
  sponsorService.post(url, data, config);
export const smoPost = (url, data = {}, config = {}) =>
  smoService.post(url, data, config);
export const agentPost = (url, data = {}, config = {}) =>
  agentService.post(url, data, config);
export const sponsorGet = (url, data = {}, config = {}) => {
  config.params = data;
  return sponsorService.get(url, config);
};
export const smoGet = (url, data = {}, config = {}) => {
  config.params = data;
  return smoService.get(url, config);
};
export const agentGet = (url, data = {}, config = {}) => {
  config.params = data;
  return agentService.get(url, config);
};
export const sponsorPut = (url, data = {}, config = {}) =>
  sponsorService.put(url, data, config);
export const smoPut = (url, data = {}, config = {}) =>
  smoService.put(url, data, config);
export const filecertPost = (url, data = {}, config = {}) =>
  filecertService.post(url, data, config);
export const filecertGet = (url, data = {}, config = {}) => {
  config.params = data;
  return filecertService.get(url, config);
};
